"use client"

import { useState } from "react"
import "../App.css"
import { Button } from "@mui/material"
import EKGAnimation from "../components/EKGAnimation"

const HomePage = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <div className="  mt-14 flex items-center justify-center bg-[#111d57] text-white px-0 text-center pb-40 md:pb-48 lg:pb-56 overflow-hidden">
        <div className="absolute inset-0 w-full h-full z-10 opacity-50">
          <EKGAnimation />
        </div>

        <div className="relative w-full text-center mt-24 z-20 px-4">
      <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white">
        <span>Empowering </span>
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#16EFA7] to-[#1386EF]">
          Healthcare
        </span>
        <span> Heroes</span>
      </h1>

      <p className="mt-6 text-base md:text-lg opacity-90 max-w-[90%] md:max-w-2/5 mx-auto text-white">
        A smarter way for healthcare workers to manage shifts, communicate effortlessly, and share knowledge, designed to support your every need.
      </p>

      <Button
        variant="contained"
        color="primary"
        sx={{
          mt: { xs: 10, sm: 6 }, // Margin-top for mobile and larger screens
          px: { xs: 6, sm: 8, md: 10 }, // Padding-x (horizontal) for different screen sizes
          py: { xs: 3, sm: 4 }, // Padding-y (vertical) for different screen sizes
          fontSize: { xs: "1rem", sm: "1.125rem" }, // Font-size for mobile and larger screens
          fontWeight: 600,
          borderRadius: "9999px",
          background: "linear-gradient(to right, #534DF4, #AA58F2)",
          boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1), 0px 4px 6px -2px rgba(0,0,0,0.05)",
          transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
          "&:hover": {
            transform: "scale(1.05)",
            background: "linear-gradient(to right, #AA58F2, #534DF4)",
          },
          position: "relative",
          zIndex: 30,
        }}
      >
        Join Us Today!
      </Button>
    </div>

        {/* Left-side images */}
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 z-30 hidden sm:block">
          <img src="up.svg" alt="Ups" className="w-12 sm:w-16 md:w-20 h-auto mx-auto" />
          <img src="down.svg" alt="Down" className="w-12 sm:w-16 md:w-20 h-auto mx-auto mt-4" />
        </div>

        {/* Right-side images */}
        <div className="absolute right-0 top-1/2 transform -translate-y-1/2 z-30 hidden sm:block">
          <img src="up.svg" alt="Ups" className="w-12 sm:w-16 md:w-20 h-auto mx-auto" />
          <img src="down.svg" alt="Down" className="w-12 sm:w-16 md:w-20 h-auto mx-auto mt-4" />
        </div>
      </div>
    </>
  )
}

export default HomePage

